import Vue from "vue";

export const UtilsPlugin = {
  install(Vue) {
    Vue.prototype.$utils = {
      // TODO: mělo by reagovat na nastavený jazyk
      localDate: function(jsonDate) {
        if (jsonDate == null) return null;
        return new Date(jsonDate).toLocaleDateString("cs");
      },

      // TODO: mělo by reagovat na nastavený jazyk
      localDateTime: function(jsonDate) {
        if (jsonDate == null) return null;
        const date = new Date(jsonDate);
        const options = {
          year: "numeric",
          month: "numeric",
          day: "numeric",
          hour: "numeric",
          minute: "numeric",
          second: "numeric",
          hour12: false,
        };
        return date.toLocaleString("cs", options);
      },

      // TODO: mělo by reagovat na nastavený jazyk
      localCurr: function(jsonNumber) {
        if (jsonNumber == null) return null;
        return jsonNumber.toLocaleString("cs", {
          style: "currency",
          currency: "CZK",
        });
      },

      capitalizeFirstLetter(word) {
        if (!word || typeof word !== "string") {
          return "";
        }

        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
      },

      // Pokud view definuje title, pak nastaví title stránky jako:
      // portal.title + " - " + title, např. : Služby na Webu - Košík
      setPageTitle(vm) {
        const title = this.getTitle(vm);
        if (title) {
          document.title = title;
        }
      },

      // Vrátí title view
      getTitle(vm) {
        const { title } = vm.$options;
        var res = Vue.prototype.$nazevObce + " - " + vm.$t("portal.title");
        if (title && title != null) {
          var suffix = title;
          if (typeof title === "function") suffix = title.call(vm);
          
          if (suffix === "") return res;

          return res + " - " + suffix;
        }
      },

      // Vrátí aktuální rok na klientu
      getCurrentYear() {
        return new Date().getFullYear();
      },

      hasResponseData(response) {
        return response != null && response.status == 200 && response.data != null;
      },

      isAuthenticationGranted(response) {
        return this.hasResponseData(response) && response.data.authenticationGranted;
      },

      isResponseBooleanTrue(response) {
        return this.hasResponseData(response) && response.data == true;
      },

    };
  },
};
